import type { AdminRole } from "@duralex/shared";

// Keyed by the shared union, so a role added to AdminRole fails the typecheck here.
const ADMIN: Record<AdminRole, true> = { owner: true, admin: true };

/** The one place a screen decides "admin+". */
export function isAdminRole(role: string | undefined | null): boolean {
  return (Object.keys(ADMIN) as string[]).includes(role ?? "");
}
